import { isTenant } from '@repo/utils';

export function canAccessInvestorType(action: string | undefined) {
  if (!isTenant('pfida')) return;
  if (!action) return;

  return ['block', 'link_to'].indexOf(action) >= 0;
}
